import React from "react";
import styled from 'styled-components';
import { connect } from 'react-redux';
import Scrollbars from "react-custom-scrollbars";
import Button from '../../../atoms/button';
import ModuleCategory from '../../../components/module_category';
import LoadingSpinner from '../../../atoms/loading';
import I10n from '../../../features/i10n';
import { getQuestions } from '../../question-management/ducks';
import MsxIcons from "../../msx-icons";
import { remote_area_question } from '../../../constants';
import { getAppLocale } from "../../../utils/app-locale";
import ProductCategory from "../../../models/ProductCategory";
import { getCompatibleRemoteAreaRIO } from '../../get-modules/ducks';
import FilterContent from "../../../components/question_list_filter_answer";
import FilterHead from "../../../components/question_list_filter_header";
import Select from 'react-select';
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../../../color-constants";
import { computeEligibleCategories } from "../../../utils/module-category";

const Container = styled.div`
  border-radius: 10px;
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 2em;
  max-width: 1100px;
  width: 100%;
  background-color: white;
  height: calc(100vh - 4em);
  overflow: hidden;
  @media (max-width: 800px) {
    max-width: 100%;
    margin: 2em 0;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: 16px 0;
  align-items: stretch;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  border-top: 2px solid #cccc;
  @media (max-width: 800px) {
    min-height: auto;
    display: none;
  }
  ${props => props.fullScreenEnabled && `
    min-height: auto;
  `}
`;

const Content = styled.div`
  flex: 1 1 auto;
  position: relative;
  display: flex;
  flex-direction: row;
  background-color: #F4F4F4;
  border-bottom: 2px solid #cccccc;

`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const SearchReferenceInput = styled.input`
  border-radius: 20px;
  width: 100%;
  max-width: none;
  padding: 5px;

  height: 30px;

  border: 1px solid #E6E6E6;

  color: #A4A4A4;
  font-size: 13px;
  font-weight: 400;
  line-height: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ::placeholder {
    color: #9FA0A4;
  }
`;

const DeviceSectionContent = styled.div`
  position: relative;
  flex: 1 1 0px;
  padding: 0 10px;
  overflow: auto;
`;

const DeviceSectionBottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0 10px;
  @media (max-width: 800px) {
    justify-content: center;
  }
`;

const DeviceSection = styled.section`
  margin-left: ${props => props.isFilterOpen && '15px'};
  display: flex;
  flex-direction: column;
  flex: 2 1 0px;
  margin-bottom: 50px;
  @media (max-width: 800px) {
    margin-left: 0;
    min-height: auto;
  }
`;

const MobileQuestionManagement = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const MobileQuestionButton = styled.div`
  display: flex;
  align-items: center;
  border-radius: 30px;
  cursor: pointer;
  background-color: ${PRIMARY_COLOR};
  background-color: var(--se-secondary, ${PRIMARY_COLOR});
  color: white;
  color: var(--se-secondary-contrast, white);
  padding-left: 5px;
  font-size: 14px;
  min-height: 32px;
`;

const ClearFilterButton = styled(MobileQuestionButton)`
  padding: 0px 10px;
`;

const LoadingMask = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  background-color: grey;
  z-index: 1;
  opacity: 0.2;
`;


const NavigationButtonSection = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column-reverse;
    align-items: flex-end;
  justify-content: center;
  @media (max-width: 800px) {
    justify-content: center;
  }
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: #626469;
  margin-top: 5px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const SearchBarTestWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  background-color: #F4F4F4;
`;

const Test = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
`;

const FilterHeadWrapper = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  ${props => props.isHidden ? 'visibility: hidden;' : ''}

   @media (max-width: 800px) {
  }
`;

const SearchHeader = styled.div`
  flex: 1 1 0px;
`;

const SearchBarWrapper = styled.div`
  flex: 1 1 0px;
  display: flex;
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  width: 99%;
  height: 30px;
  box-sizing: border-box;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: -8px;
  position: relative;
`;

const FilterContentWrapper = styled.div`
  width: ${props => props.isFilterOpen ? '350px' : '0'};
  display: ${props => props.isFilterOpen ? 'flex' : 'none'};
  margin-top:${props => props.isFilterOpen ? '-39px' : '0'};
  position: relative;

  @media (max-width: 800px) {
    background-color: #F4F4F4;
    flex-grow: 1;
    position: absolute;
    top: 50px;
    bottom: 50px;
    z-index: 1000;
    width: 100%;
    left: 0;
    right: 0;
    box-sizing: border-box;
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const ContentWrapperMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-top: 2px solid #cccc;
  padding: 10px 15px 0 15px;
`;

const SearchBarTestWrapperMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const SearchBarWrapperMobile = styled.div`
  flex-grow: 1;
  margin-left: -5px;
  width: 100%;
  margin-top: 10px;
`;

const SearchBarMobile = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 0px;
  margin-left: -36px;
  padding-left: 15px;
`;

const SearchBarIcon = styled.div`
  position: relative;
  left: 35px;
`;

const FilterHeadWrapperMobile = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  width: 100%;
  ${props => props.isHidden ? 'visibility: hidden;' : ''}
`;

const ButtonWrapper = styled.div `
  margin-top: 10px;
  padding: 0 10px;
`;

class ModalAddRemoteArea extends React.PureComponent {

  constructor(props) {
    super(props);
    this._isMounted = false;

    this.state = {
      search: '',
      moduleSelected: null,
      categories: [],
      questionsWithAnswers: {},
      remainingCriteria: null,
      sharedOptions: {},
      baseCriteria: null,
      selectedDeviceProtocol: null,
      openMobileQuestionsCallback: null,
      isFilterOpen: window.innerWidth > 800
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.getAggregatedQuestions().then((success) => {
      this.refreshModules({}, true);
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  removeSelectedModuleIfNotInResult(references) {
    const referencesId = references.map((e) => { return e.id; });
    if (this.state.moduleSelected) {
      if (referencesId.indexOf(this.state.moduleSelected.id) === -1) {
        this.updateStateIfMounted({ moduleSelected: null });
      }
    }
  }

  filterCategories(categories) {
    const _categories = (categories || []).map(cat => {
      let categoryData = (cat || {});
      if (categoryData.hasOwnProperty('rawData')) {
        categoryData = categoryData.rawData;
      }
      return new ProductCategory(categoryData);
    });
    return _categories.filter(c => (c?.references || []).length);
  }

  refreshModules(questionsWithAnswers, initialCall = false) {
    this.props.getCompatibleRemoteAreaRIO(this.props.configurationId, this.buildCriteriaPayload(questionsWithAnswers))
      .then((payload) => {
        let categories = payload.categories;
        const allReferences = [];
        for (let category of categories) {
          allReferences.push(...category.references);
        }
        if (initialCall) {
          this.updateStateIfMounted({ categories: this.filterCategories(categories), remainingCriteria: payload.remainingCriteria, baseCriteria: payload.remainingCriteria, sharedOptions: payload.sharedCriteria });
        } else {
          this.updateStateIfMounted({ categories: this.filterCategories(categories), remainingCriteria: payload.remainingCriteria, sharedOptions: payload.sharedCriteria });
        }
        this.removeSelectedModuleIfNotInResult(allReferences);
      });
  }

  updateStateIfMounted(objectToAffect) {
    if (this._isMounted) {
      return this.setState(objectToAffect);
    }
  }

  getQuestionMap() {
    const questionMap = {};
    for (const questionCategory of this.props.questions.aggregatedQuestions) {
      for (const question of questionCategory.questions) {
        questionMap[question.questionKey] = question;
      }
    }
    return questionMap;
  }

  buildCriteriaPayload(questionsWithAnswers) {
    const questionMap = this.getQuestionMap();
    const payload = {};
    for (const [key, answer] of Object.entries(questionsWithAnswers)) {
      payload[questionMap[key].criteria] = answer;
    }
    return payload;
  }

  get numberQuestionsAnswered() {
    return Object.keys(this.state.questionsWithAnswers).length;
  }

  get haveQuestionsAnswered() {
    return !!Object.keys(this.state.questionsWithAnswers).length;
  }

  onAnswerChanged = (questionsWithAnswers, initialCall = false) => {
    this.updateStateIfMounted({ questionsWithAnswers: questionsWithAnswers });
    this.refreshModules(questionsWithAnswers, initialCall);
  }

  resetQuestionAnswers() {
    this.onAnswerChanged({});
  }

  get hasSelection() {
    return this.state.moduleSelected !== null;
  }

  handleSearchChange = (event) => {
    this.setState({ search: event.currentTarget.value });
  }

  renderModules = () => {
    const appLocale = getAppLocale();
    const categories = this.state.categories || [];
    const eligibleCategories = computeEligibleCategories(categories, this.state.search, this.props.configuration.showPrecommercializedProducts) || [];

    // Do not show the indications if the modules are loading.
    if (!this.props.compatibleIslandBC.isLoading && !this.props.questions.isLoading) {
      if (!categories.length && !this.haveQuestionsAnswered) {
        return <p>{I10n.getAndReplace(`modal.add_module.suggest.empty`, appLocale)}</p>;
      }
      if (!eligibleCategories.length) {
        return <p>{I10n.get(`modal.add_module.suggest.no-match`)}</p>;
      }
    }

    return eligibleCategories.map(category => {
      return <ModuleCategory
        id={category.translationKey}
        title={I10n.getOrDefault(`category.${category.translationKey}.name`, category.label, 'data')}
        label={category.label}
        description={I10n.getOrDefault(`category.${category.translationKey}.description`, category.description, 'data')}
        detailedDescription={category.detailedDescription}
        image={category.imageURL}
        references={category.references}
        setSelectedDevice={(mod) => {
          this.updateStateIfMounted({ moduleSelected: mod });
          if (mod?.slaveProtocols?.length >= 1) {
            this.updateStateIfMounted({ selectedDeviceProtocol: mod?.slaveProtocols[0].name });
          }
        }}
        selectedDevice={this.state.moduleSelected}
        key={category.label}
        withCount={true}
        onOpenStateChange={(isOpen, ref) => {
          this.forceUpdate();
          if (isOpen) {
            setTimeout(() => {
              this.scrollComponent.view.scrollTop = ref.current.offsetTop;
            }, 0);
          }
        }}
        // Do not use force forceOpen to open if still loading
        forceOpen={!this.props.questions.isLoading && (this.haveQuestionsAnswered || eligibleCategories.length === 1)}
      ></ModuleCategory>
    });
  }

  toggleMobileFilter = (status) => {
    this.updateStateIfMounted({ mobileFilterOpened: status });
  }

  renderMobileQuestionButton = () => {
    return (
      <ContentWrapperMobile id='ContentWrapper-Mobile' fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        {(this.props.questions.isLoading || this.props.questions.aggregatedQuestions.length) > 0 &&
          <SearchBarTestWrapperMobile id='SearchBarTestWrapper-Mobile'>
            <FilterHeadWrapperMobile id='FilterHeadWrapper-Mobile' isHidden={this.state.isFilterOpen} onClick={() => this.setState(prevState => ({ isFilterOpen: !prevState.isFilterOpen }))}>
              <FilterHead
                isLoading={this.props.isLoading}
                toggleFilter={this.toggleFilter}
                numberQuestionsAnswered={this.numberQuestionsAnswered}
              />
            </FilterHeadWrapperMobile>
            <SearchBarWrapperMobile id='SearchBarWrapper-Mobile'>
              <SearchBarMobile id='SearchBar-Mobile'>
                <SearchBarIcon id='SearchBarIcon-Mobile'>
                  <MsxIcons name="search" size="small"></MsxIcons>
                </SearchBarIcon>
                <SearchReferenceInput
                  id="head-device-selector-screen-search-input"
                  type="search"
                  placeholder={I10n.get(`modal.add_module.search.placeholder`)}
                  value={this.state.search}
                  onChange={this.handleSearchChange}
                  style={{ paddingLeft: '50px' }}
                  color='#E6E6E6'
                ></SearchReferenceInput>
              </SearchBarMobile>
            </SearchBarWrapperMobile>
          </SearchBarTestWrapperMobile>
        }
      </ContentWrapperMobile>
    );
  }

  renderProtocols = () => {
    return (this.state.moduleSelected?.slaveProtocols || []).map((protocol, i) => {
      return (
        { value: protocol.name, label: protocol.name}
      );
    });
  }

  render = () => {
    const { aggregatedQuestions = [] } = this.props.questions || {};
    const hasQuestions = aggregatedQuestions.length > 0;
    return (
      <Container>

        <Header id="modal-add-remote-area">
          <TitleWrapper id="modal-add-remote-area-titleWrapper">
            <Title>{I10n.get('modal.add_module.title')}</Title>
              {!this.props.disableCrossModal && (
              <CloseIcon onClick={(e) => {
                e.preventDefault();
                this.props.closeModal();
              }}>
                <MsxIcons name="close"></MsxIcons>
              </CloseIcon>
            )}
            </TitleWrapper>
            <Subtitle>{I10n.getOrDefault(`modal.${this.props.configuration.starterType}.subtitle`, I10n.get('modal.subtitle'))}</Subtitle>
          </Header>

          <Body id="modal-add-remote-area-body">
            <ContentWrapper id="modal-add-remote-area-contentWrapper">
                <SearchBarTestWrapper id='HeadDevice 3'>
                  {hasQuestions && <Test id="modal-replace-module-test">
                    <FilterHeadWrapper
                      onClick={() => {
                        this.setState(prevState => {
                          return { isFilterOpen: !prevState.isFilterOpen }
                        });
                      }}
                    >
                      <FilterHead
                        isLoading={this.props.questions.isLoading}
                        toggleFilter={this.toggleFilter}
                        numberQuestionsAnswered={this.numberQuestionsAnswered}
                      />
                    </FilterHeadWrapper>
                  </Test>}
                  <SearchBarWrapper>
                    <SearchHeader id='AddModal 1'>
                      <SearchBar id='AddModal 2'>
                        <SearchBarIcon>
                          <MsxIcons name="search" size="small"></MsxIcons>
                        </SearchBarIcon>
                        <SearchReferenceInput
                          id="add-modal-screen-search-input"
                          type="search"
                          placeholder={I10n.get(`modal.add_module.search.placeholder`)}
                          value={this.state.search}
                          onChange={this.handleSearchChange}
                          style={{ paddingLeft: '50px' }}
                          color='#E6E6E6'
                        ></SearchReferenceInput>
                      </SearchBar>
                    </SearchHeader>
                </SearchBarWrapper>
              </SearchBarTestWrapper>
            </ContentWrapper>

            <Content id="modal-remote-area-island-content">
              {hasQuestions && <FilterContentWrapper isFilterOpen={this.state.isFilterOpen}>
                  <FilterContent
                    aggregatedQuestions={this.props.questions.aggregatedQuestions}
                    isLoading={this.props.questions.isLoading}
                    onAnswerChanged={this.onAnswerChanged}
                    questionsWithAnswers={this.state.questionsWithAnswers}
                    questionMap={this.getQuestionMap()}
                    resultsLoading={this.props.compatibleIslandBC.isLoading}
                    remainingOptions={this.state.remainingCriteria}
                    sharedOptions={this.state.sharedOptions}
                    resetQuestionAnswers={this.resetQuestionAnswers}
                    mobileFilterOpened={this.state.mobileFilterOpened}
                    toggleMobileFilter={this.toggleMobileFilter}
                  />
              </FilterContentWrapper>}
              <DeviceSection>
                <MobileQuestionManagement>
                  {!this.props.questions.isLoading && this.props.questions?.aggregatedQuestions?.length > 0 && this.renderMobileQuestionButton()}
                  {this.haveQuestionsAnswered && (
                    <ClearFilterButton onClick={(e) => {
                      e.preventDefault();
                      this.resetQuestionAnswers();
                    }}>
                      {I10n.get(`screen.head_device_selector_screen.plc.answers_reset_hover`)}
                    </ClearFilterButton>
                  )}
                </MobileQuestionManagement>
                <DeviceSectionContent>
                  {(this.props.questions.isLoading || this.props.compatibleIslandBC.isLoading) &&
                    <LoadingMask>
                      <LoadingSpinner></LoadingSpinner>
                    </LoadingMask>}
                  <Scrollbars ref={c => { this.scrollComponent = c }}>
                    {this.renderModules()}
                  </Scrollbars>
                </DeviceSectionContent>

              </DeviceSection>
            </Content>
            <NavigationButtonSection>
              <ButtonWrapper>
                <Button id="add-remote-area-button" importance="emphasized" primary disabled={!this.hasSelection}
                    onClick={event => {
                      this.props.addNewRemoteArea(this.state.moduleSelected, this.state.selectedDeviceProtocol,this.state.questionsWithAnswers);
                      this.props.closeModal();
                    }}
                  >
                    {I10n.get('modal.add_module.next')}
                  </Button>
                </ButtonWrapper>
              <DeviceSectionBottom>
                {this.hasSelection && this.state.moduleSelected?.slaveProtocols?.length >= 1 && (
                    <Select
                      isDisabled={!this.hasSelection || this.state.moduleSelected?.slaveProtocols?.length < 2}
                      value={{ value: this.state.selectedDeviceProtocol, label: this.state.selectedDeviceProtocol}}
                      onChange={(e) => {
                        this.setState({ selectedDeviceProtocol: e.value });
                      }}
                      styles={{control: (provided, state) => {
                        return { ...provided, marginTop: 10 };
                      }}}
                      options={this.renderProtocols()}
                      isSearchable={false}
                      menuPlacement={"top"}>
                  </Select>
                )}
              </DeviceSectionBottom>
            </NavigationButtonSection>
        </Body>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    getAggregatedQuestions: () => dispatch(getQuestions(remote_area_question)),
    getCompatibleRemoteAreaRIO: (configurationId, criteria) => dispatch(getCompatibleRemoteAreaRIO(configurationId, criteria)),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(ModalAddRemoteArea);
